namespace $.$$ {
	$mol_style_define( $shm_hitalama_map_widget_float_page, {
		width: '100%',
		height: '100%',
		minWidth: 0,
		minHeight: 0,
		Head: { flex: { shrink: 0 } },
		Title: { minWidth: 0, padding: 0 },
		Name: { minWidth: 0, width: '100%' },
		Body: { minWidth: 0, minHeight: 0, overflow: 'hidden', flex: { basis: 0, grow: 1, shrink: 1 } },
		Body_content: { padding: 0, minWidth: 0, minHeight: 0, height: '100%' },
	} )
}
